import { defineStore } from "pinia";
import { ref } from "vue";

export const useSelectedListsStore = defineStore(
  "selectedLists",
  () => {

    const tonos = ref({});

    function saveTonos(data) {
        tonos.value = data;
    }
    
    return { tonos, saveTonos };
  },
);